import http from "../http-common";

class ReportDataService {
    getProductInventory(params = {}) {
        return http.get('/reports/product-inventory', { params });
    }

    getTotalSales(params = {}) {
        return http.get('/reports/total-sales', { params });
    }

    getSalesByProduct(params = {}) {
        return http.get('/reports/sales-by-product', { params });
    }

    getEarningsByBatch(params = {}) {
        return http.get('/reports/earnings-by-batch', { params });
    }

    // Payments reports
    getPaymentsActiveMembershipsByMonth(params = {}) {
        return http.get('/reports/payments/active-memberships-by-month', { params });
    }

    getPaymentsActiveClientsCounts(params = {}) {
        return http.get('/reports/payments/active-clients-counts', { params });
    }

    getPaymentsIncomeByDateRange(params = {}) {
        return http.get('/reports/payments/income-by-date-range', { params });
    }

    getCleaningHoursWagesByCleaner(params = {}) {
        return http.get('/reports/cleaning/hours-wages-by-cleaner', { params });
    }

    getCleaningHoursByClient(params = {}) {
        return http.get('/reports/cleaning/hours-by-client', { params });
    }

    getClinicAppointmentBookings(params = {}) {
        return http.get('/reports/clinic/appointment-bookings', { params });
    }

    getAttendanceStudentSummary(params = {}) {
        return http.get('/reports/attendance/student-summary', { params });
    }
}

export default new ReportDataService();

